export default __webpack_public_path__ + "static/media/portada_PedroGarza_ENG.4997820e.jpg";